import { createContext, ReactNode, FC } from 'react';

type CheckoutServerVarsContext = {
    isMobile: boolean;
    isEnhancedBuyerIncentivesClientVariant: boolean;
};

export const CheckoutServerVarsContext = createContext<CheckoutServerVarsContext>({
    isMobile: false,
    isEnhancedBuyerIncentivesClientVariant: false,
});

type Props = {
    children: ReactNode;
    isMobile: boolean;
    isEnhancedBuyerIncentivesClientVariant: boolean;
};

export const CheckoutServerVarsContextProvider: FC<Props> = ({
    children,
    isMobile,
    isEnhancedBuyerIncentivesClientVariant,
}) => (
    <CheckoutServerVarsContext.Provider
        value={{
            isMobile,
            isEnhancedBuyerIncentivesClientVariant,
        }}
    >
        {children}
    </CheckoutServerVarsContext.Provider>
);
